export default "__VITE_ASSET__BAV47lT4__"